import { useOutletContext } from 'react-router-dom'
import { ViewMode } from '../toggle-view'
import { Params } from '@acme/core'

export function useDigitacaoContext() {
    return useOutletContext<{
        view: ViewMode
        periodo: [string, string]
        queryParams: Params
    }>()
}
